export const BEARER = 'Bearer';
export const AUTHORIZATION_HEADER = 'Authorization';
export const OPENING_HOUR = 8;
export const CLOSING_HOUR = 21;
export const STO_EANS_FILTER_KEY = '@stoEans';
